<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {getSelectedCity} from "../utils";
    import {ManagerVehicles} from "../models/manager-vehicles";

    export let title: string;
    export let text: string;
    export let button: string;
    export let cities: Array<any> = [];
    export let error: string = null;
    let buscarPor: string = 'placa';

    let selectedCity: any = null;
    let placa: string = '';
    let order: string = '';
    export let formStyle: string = 'naui-field';
    export let km: number;
    const dispatch = createEventDispatcher();

    $:isValid = [
        !!km,
        !!selectedCity,
        !!placa || !!order
    ].every(o => !!o);

    onMount(() => {
        const tmp = getSelectedCity();
        if (tmp) {
            const find = cities.find(c => c.id === tmp);
            selectedCity = find ? find : null;
        }

        ManagerVehicles.getInstance().selected$.subscribe((next) => {
            const vehicle = next;
            placa = vehicle ? vehicle.placa ?? '' : null;
        });
    });

    function valid() {
        const options = [
            !!km,
            !!selectedCity,
            !!placa || !!order
        ];
        return options.every(o => !!o);
    }

    function search() {
        if (valid()) {
            localStorage.setItem('selectedCity', JSON.stringify({
                id: selectedCity.id,
                name: selectedCity?.name ?? ''
            }));
            dispatch('search', {
                ciudad: selectedCity.id,
                km,
                placa: placa?.toUpperCase() ?? null,
                order,
                type: buscarPor
            })
        }
    }
</script>
<section class="py-2 mb-1">
    <div class="w-100 max-w-1200px mx-auto">
        <div class="mb-15">
            <h3>{title}</h3>
            {#if text}
                <div class="mt-ii">
                    <p>{text}</p>
                </div>
            {/if}
        </div>
        <div class="{formStyle} mb-1">
            <select class="naui-input" bind:value={buscarPor}>
                <option selected value="placa">Busca por placa</option>
                <option value="order">Busca por número de pedido</option>
            </select>
            <span></span>
        </div>
        {#if buscarPor === 'placa'}
            <div class="{formStyle} mb-1">
                <input class="naui-input"
                       placeholder="Ingresa tu placa"
                       bind:value={placa}>
            </div>
        {:else if buscarPor === 'order'}
            <div class="{formStyle} mb-1">
                <input class="naui-input"
                       type="text"
                       placeholder="Ingresa el número del pedido"
                       bind:value={order}>
            </div>
        {/if}

        <div class="{formStyle} mb-1">
            <input class="naui-input"
                   type="number"
                   placeholder="Kilometraje actual"
                   bind:value={km}>
        </div>
        <div class="{formStyle} mb-1">
            <select class="naui-input" bind:value={selectedCity}>
                <option selected hidden value={null}>Ciudad</option>
                {#each cities as city}
                    <option value={city}>{city.name}</option>
                {/each}
            </select>
            <span></span>
        </div>
        <div class="{formStyle} mb1">
            <button class="btn accent"
                    on:click={search}
                    class:disabled={!isValid}>
                {button}
            </button>
        </div>
        {#if error}
            <div class="error">
                {error}
            </div>
        {/if}
    </div>
</section>

<style>
    .field-inline {
        display: inline-block;
    }

    .error {
        color: red;
        text-align: center;
    }
</style>